/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { PaginationApi } from './pagination-api';

export class PaginationChangeEvent {
  paginationApi: PaginationApi;
  currentPage: number;
  pageSize: number;
}
